import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SalesEvolutionChart } from "../charts/SalesEvolutionChart";
import { ComparisonChart } from "../charts/ComparisonChart";

interface RevenueChartsSectionProps {
  currentData: { date: string; amount: number }[];
  previousData: { date: string; amount: number }[];
}

export const RevenueChartsSection = ({ currentData, previousData }: RevenueChartsSectionProps) => {
  return (
    <div className="grid gap-6 md:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>Évolution des Ventes</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <SalesEvolutionChart data={currentData || []} />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Comparaison avec le mois précédent</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[300px]">
            <ComparisonChart 
              currentData={currentData || []}
              previousData={previousData || []}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};